import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatIconModule } from '@angular/material/icon';
import { CommonSingleSelector } from './components/common-single-selector/common-single-selector.component';
import { CustomSearchFieldComponent } from './components/custom-search-field/custom-search-field.component';
import { CommonMultiSelector } from './components/common-multi-selector/common-multi-selector.component';

@NgModule({
  declarations: [
    CommonSingleSelector,
    CustomSearchFieldComponent,
    CommonMultiSelector,
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatFormFieldModule,
    MatSelectModule,
    MatIconModule,
  ],
  exports: [
    CommonSingleSelector,
    CustomSearchFieldComponent,
    CommonMultiSelector,
  ],
})
export class SharedComponentsModule {}
